<template>
    <div>
        <h3>Amenities</h3>
        <p class="margin_bottom">Select all features that provide comfort or convenience to tenants</p>
        <div class="md-layout">
            <amenity-group v-for="group in groups" :amenityGroup="group" :key="group.name"></amenity-group>
        </div>
        <!--<md-button @click="selectAll" class="md-raised md-primary">Select All</md-button>-->
    </div>
</template>
<script>
    import AmenityGroup from "./AmenityGroup.vue";
    
    export default {
        name: "BuildingAmenities",
        components: {
           AmenityGroup
        },
        props: {
            groups: Array
        },
        methods: {
            //selectAll() {
            //    this.amenityGroups.forEach(g => {
            //        g.items.forEach(a => {
            //            a.selected = true;
            //        });
            //    });
            //}
        }
    };
</script>
<style>
    .md-switch .md-switch-label {
        color: rgba(0, 0, 0, 0.8);
    }
</style>
